;(function() {
  'use strict'

  Controller.$inject = ["subscriberService", "uacService", "externalPanelService"];
  angular.module('app.core').component('channelFormExternalPanel', {
    templateUrl: 'channel-form-external-panel.html',
    controller: Controller,
    bindings: {
      channel: '<',
      survey: '<',
      cost: '<',
      onCostShouldUpdate: '&',
      onSave: '&',
    },
  })

  /* @ngInject */
  function Controller(subscriberService, uacService, externalPanelService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.change = change
    ctrl.canChange = canChange

    function onInit() {
      ctrl.subscriber = subscriberService.getSubscriber()

      externalPanelService.list().then(function(panels) {
        ctrl.pickable = panels.filter(uacService.canPickPanelPartner)
        if (!ctrl.channel.provider) {
          var provider = getDefaultProvider()
          if (provider) {
            ctrl.channel.provider = provider
          }
        }
      })

      ctrl.onCostShouldUpdate()
    }

    // the account's default panel, or its only available panel the user can pick
    function getDefaultProvider() {
      var provider = _.find(ctrl.pickable, {
        id: ctrl.subscriber.data.defaultPanelPartnerId,
      })
      var available = ctrl.pickable.filter(function(panel) {
        return _.includes(
          ctrl.subscriber.data.availablePanelPartnerIds,
          panel.id
        )
      })
      if (!provider && available.length === 1) {
        provider = available[0]
      }
      return provider
    }

    function change() {
      externalPanelService
        .showSelectorDialog(ctrl.pickable)
        .then(function(provider) {
          ctrl.channel.provider = provider
        })
    }

    function canChange() {
      return _.some(ctrl.pickable, function(panel) {
        return panel.id !== ctrl.channel.provider.id
      })
    }
  }
})()
